import { Service, inject } from '@piwikpro/platform';
import { Notifications } from '../Notifications';

@Service()
export class NotifyAboutCreation {
  constructor(
    @inject('NotificationCrate.notifications') private readonly notifications: Notifications,
  ) {}

  async intercept(req: any, next: any) {
    const id = this.notifications.push({
      text: 'components:notifications.create.processing',
      type: 'pending',
      autoCloseSeconds: 0,
      onClose: req.onNotificationRemove,
    });

    try {
      const resp = await next(req);

      this.notifications.update(id, {
        text: 'components:notifications.create.success',
        type: 'success',
        autoCloseSeconds: 5,
        onClose: req.onNotificationRemove,
      });

      return resp;
    } catch (err: any) {
      const status = err.name === 'InvalidRequestError' ? 'invalid' : 'failed';
      let message = `components:notifications.create.${status}`;

      if (err.name === 'ConflictError' && Array.isArray(err.errors)) {
        message = `platform:${err.errors[0].code}`;
      }

      this.notifications.update(id, {
        text: message,
        type: 'error',
        autoCloseSeconds: 5,
        onClose: req.onNotificationRemove,
      });

      throw err;
    }
  }
}
